// extracted by mini-css-extract-plugin
export default {"root":"Index__root--ijWGR","container":"Index__container--S6PM7","heading":"Index__heading--yXM0x"};